import { createAction, props } from '@ngrx/store';
import { ICustomerMobileNumberRequest } from '../models/update-mobile.model';

export const updateMobileNumberRequest = createAction(
  '[UpdateMobileNumber] Update Mobile Number Request',
  props<{ customerId: string; employeeId: string; request: ICustomerMobileNumberRequest }>()
);

export const updateMobileNumberSuccess = createAction('[UpdateMobileNumber] Update Mobile Number Success', props<{ response: string }>());

export const updateMobileNumberFailure = createAction('[UpdateMobileNumber] Update Mobile Number Failure', props<{ error: Error | any }>());
